import { render, staticRenderFns } from "./IntendsToReplaceRadiatorFormPart.vue?vue&type=template&id=2ea86077"
import script from "./IntendsToReplaceRadiatorFormPart.vue?vue&type=script&lang=js"
export * from "./IntendsToReplaceRadiatorFormPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports